import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class CsvLoader {

  public loginidToVehicleId = new Array<CSVForSearch>();

  constructor(){

    fetch(environment.loginUserCsvUrl,{
      method:'GET'
    })
      .then(req => req.text())
      .then(csv =>{
        const tmp = csv.split('\r\n');

        for (let index = 1; index < tmp.length; index++) {
          //カンマ区切りで配列に分割
          const row = tmp[index].split(',');
          const data: CSVForSearch = {
            id: Number.parseInt(row[0]),
            loginId: row[1],
            auth: row[2],
            fleetId:  row[3],
            fleetName: row[4],
            vehicleNumber: row[5],
            vehicleName:row[6]
          };
          this.loginidToVehicleId.push(data);
        }
     })
  }
}
export interface CSVForSearch {
  id: number;
  loginId: string;
  auth: string;
  fleetId:  string;
  fleetName: string;
  vehicleNumber:string;
  vehicleName: string;
}



// WEBPACK FOOTER //
// ./src/providers/servicer/csv-loader.ts